import { Guid } from '@Shared.Angular/@types/guid';

export enum FormThemeStatus {
  Draft = 0,
  Published = 1
}

export enum FormThemeLogoAlignment {
  Left = 0,
  Center = 1,
  Right = 2
}

export enum FormThemeFontColorType {
  Default = 0,
  Custom = 1
}

export default interface IFormThemeDetail {
  id: Guid;
  name: string;
  description: string;
  logoFileId: Guid | null;
  logoAlignment: FormThemeLogoAlignment | null;
  fontColors: string[];
  formBackgroundColor: string | null;
  primaryButtonColor: string | null;
  fontColorType: FormThemeFontColorType;
  isDefaultTheme: boolean;
  status: FormThemeStatus | null;
  isDraftVersionAvailable: boolean;
}
